(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FlightSearch',
	};

	var form_id = 'flightsearch-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var flight_type_radio   = $('.flight-type-switch');
		var base_dates_radio    = $('.dates-type-switch');
		var gmt_username_radio  = $('.gmt-user-switch');
		var cruise_lookup_field = $('.cruise-lookup');
		var return_field        = $('.return-date');

		// change flight type on form load
		if ($('#' + form_id + 'flight_type-0').is(':checked')) {
			$('.openjaw-field').addClass('hidden');
		} else if ($('#' + form_id + 'flight_type-1').is(':checked')) {
			$('.openjaw-field').addClass('hidden');
			return_field.addClass('hidden');
		} else {
			$('.openjaw-field').removeClass('hidden');
			$('.departing-field').addClass('hidden');
		}

		// toggle cruise booking lookup visibility on form load
		if ($('#' + form_id + 'base_dates-1').is(':checked')) {
			cruise_lookup_field.removeClass('hidden');
		}

		// pre-select cruise booking # on page load (if available)
		if ($('#' + form_id + 'reservation_id').val() !== '') {
			$('#' + form_id + 'cruise_booking_lookup').prop('disabled', true);

			$('.reset-booking-typeahead').removeClass('hidden');
		}

		// hide the max hours per connection (if necessary) on page load
		if ($('#' + form_id + 'direct_flight').is(':checked')) {
			$('.max-connection-time-field').addClass('hidden');
		}

		// toggling flight type oneway/roundtrip/openjaw
		flight_type_radio.on('change', function onFlightTypeChange(event)
		{
			var flight_type = $(this).val();

			switch (flight_type) {
				case 'oneway':
					$('.departing-field').removeClass('hidden');
					$('.openjaw-field').addClass('hidden');
					return_field.addClass('hidden');
				break;

				case 'roundtrip':
					$('.departing-field').removeClass('hidden');
					$('.openjaw-field').addClass('hidden');
					return_field.removeClass('hidden');
				break;

				case 'openjaw':
					$('.departing-field').addClass('hidden');
					$('.openjaw-field').removeClass('hidden');
					return_field.removeClass('hidden');
				break;
				default:
					// to satisfy eslint >_<
				break;
			}
		});

		// toggling base dates on (manual/cruise)
		base_dates_radio.on('change', function onBaseDatesChange(event)
		{
			var dates_based_on = $(this).val();

			if (dates_based_on === 'cruise') {
				cruise_lookup_field.removeClass('hidden');
				return;
			}

			cruise_lookup_field.addClass('hidden');
			resetCruiseLookupFields();
		});

		// toggling max hours per connection when direct flights option is checked
		$('#' + form_id + 'direct_flight').on('change', function onDirectFlightChange(event)
		{
			if ($(this).is(':checked')) {
				$('.max-connection-time-field').addClass('hidden');
			} else {
				$('.max-connection-time-field').removeClass('hidden');
			}
		});

		// Toggling gmt username field
		gmt_username_radio.on('change', function onGmtUsernameRadioChange(event)
		{
			var agent_has_gmt_username = $(this).val();

			if (agent_has_gmt_username === '1') {
				$('.gmt-username-field').removeClass('hidden');
				return;
			}

			$('.gmt-username-field').addClass('hidden');
		});

		$('#flightsearch-departure_date').on('dp.change', function populateDropoff(event)
		{
			var return_date = '';

			if ($('#flightsearch-return_date').val() !== '') {
				return_date = Date.parse($('#flightsearch-return_date').val());
			}

			if (
				event.date
				&& (
					return_date === '' ||
					return_date <= event.date
				)
			) {
				$('#flightsearch-return_date').data('DateTimePicker')
											  .date(event.date.add(1, 'days'));
			}
		});

		$('.toggle-airport-name').on('click', function showTypeaheadForm(event)
		{
			event.preventDefault();
			showAirportTypeahead($(this));
		});

		$('#flightsearch-airport_search').click(function clearIt()
		{
			$(this).val('');
		});

		// Cruise Booking # lookup typeahead
		Adzuki.Typeahead(
			$('#' + form_id + 'cruise_booking_lookup'),
			'/CruiseSearch/searchYetToDepart',
			function onSelect(cruise_component, $self, typeahead) {
				typeahead.setHiddenValue(cruise_component.confirmation_number);
				$self.val(cruise_component.confirmation_number);
				$self.prop('disabled', true);

				updateFlightDates(cruise_component);

				$('#' + form_id + 'reservation_id').val(cruise_component.reservation_id);
				$('#' + form_id + 'cruise_ship_name').val(cruise_component.ship_name);
				$('#' + form_id + 'itinerary_id').val(cruise_component.itinerary_id);
				$('.reset-booking-typeahead').removeClass('hidden');
			}
		);

		// click to reset the cruise booking # selected from the typeahead
		$('.reset-booking-typeahead').click(function onClickResetTypeahead(event)
		{
			event.preventDefault();

			resetCruiseLookupFields();
		});
	};

	function updateFlightDates(cruise_component)
	{
		if (cruise_component.departure_date) {
			$('#' + form_id + 'departure_date')
				.data('DateTimePicker')
				.date(moment(cruise_component.departure_date).subtract(1, 'days'));
		}

		// roundrip search, also update return date
		if (
			cruise_component.return_date
			&& $('#' + form_id + 'flight_type-0').is(':checked')
		) {
			$('#' + form_id + 'return_date')
				.data('DateTimePicker')
				.date(cruise_component.return_date);
		}
	}

	function resetCruiseLookupFields()
	{
		$('.reset-booking-typeahead').addClass('hidden');

		$('#' + form_id + 'cruise_booking_lookup').prop('disabled', false);
		$('#' + form_id + 'cruise_booking_lookup').val('');
		$('#' + form_id + 'reservation_id').val('');
		$('#' + form_id + 'itinerary_id').val('');
		$('#' + form_id + 'cruise_confirmation_number').val('');
		$('#' + form_id + 'cruise_ship_name').val('');
	}

	function showAirportTypeahead(edit_btn)
	{
		var parent            = edit_btn.parent();
		var airport_typeahead = parent.next('.airport-typeahead');

		parent.addClass('hidden');
		airport_typeahead.removeClass('hidden');

		// remove saved id
		airport_typeahead.find('input[type="hidden"]')
						 .first().val('');
	}

}(jQuery, window.Adzuki || {}));
